module.exports = __webpack_public_path__ + "static/media/icon-arrow-white.bf7002d4.svg";